import Component_PostProcessImage_9f310fa320160e2ed123d6f033a40b01 from "../../../../content/examples/post-process/image/PostProcessImage";
import Devtool_PostProcessImage_9f310fa320160e2ed123d6f033a40b01 from "!!@devtool/loader!../../../../content/examples/post-process/image/PostProcessImage";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_PostProcessImage_9f310fa320160e2ed123d6f033a40b01,
  Devtool_PostProcessImage_9f310fa320160e2ed123d6f033a40b01,
  DevTool,
  React
};